import { render, staticRenderFns } from "./PreActualReportNew.vue?vue&type=template&id=5c2e7150&scoped=true&"
import script from "./PreActualReportNew.vue?vue&type=script&lang=js&"
export * from "./PreActualReportNew.vue?vue&type=script&lang=js&"
import style0 from "./PreActualReportNew.vue?vue&type=style&index=0&id=5c2e7150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e7150",
  null
  
)

export default component.exports